import React from 'react';
import PropTypes from 'prop-types';

const ProcessDetails = (props) => {
  const { data = [], setHyperProcessId, activeId } = props;

  return (
    <div className="process-details">
      {data.length === 0 ? (
        <div className="no-data">No data available</div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th className="text-end">Leads</th>
            </tr>
          </thead>
          <tbody>
            {data.map((val, index) => {
              return (
                <tr
                  key={index}
                  className={`cursor-pointer ${val.process_id === activeId ? 'fw-bolder text-primary' : ''}`}
                  style={{
                    background:
                      val.process_id === activeId
                        ? '#2cabe333'
                        : val?.process_status_final === 'true' && Number(val?.pending_count) === 0
                          ? '#ff505033'
                          : val?.process_status_final === 'false'
                            ? '#ff505066'
                            : ''
                  }}
                  onClick={() => setHyperProcessId(val.process_id)}>
                  <td>{val.process_name}</td>
                  <td className="text-end">{val.pending_count}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

ProcessDetails.propTypes = {
  data: PropTypes.array,
  setHyperProcessId: PropTypes.func,
  activeId: PropTypes.any
};

export default ProcessDetails;
